export default __webpack_public_path__ + "static/media/line-gradient.984723e2.png";